import { enforce } from "vest";
import {isValidEmail} from "./validations";

enforce.extend({
    isValidEmail,
});

export default enforce;